import { DettachLeadSourcesApi } from 'resources/LeadSources/types';

import { LeadSource } from 'components/Account/LeadSource/LeadSourcesAutocomplete';
import RestAPI from 'components/Common/restApi';

import { LeadSourceUuid } from '.';

type Params = {
  page_size: number;
  sort_direction: string;
  sort_column: string;
};

type ShowParams = {
  uuid: LeadSourceUuid;
};

interface bulkDetachParams {
  customer_ids?: number[];
  job_uuids?: string[];
  estimate_uuids?: string[];
}

export type LeadSourceAttachParams = {
  leadSourceUuid: string;
  sourceUuid: string;
  resourceType: string;
};

export default class LeadSourcesApi {
  static show({ uuid }: ShowParams) {
    return RestAPI.get(`/alpha/lead_sources/${uuid}`);
  }

  static index(params: Params) {
    return RestAPI.getWithQueryString<{ data: LeadSource[] }, Params>('/alpha/lead_sources', params);
  }

  static create(params: Params) {
    return RestAPI.postWithFormData('/alpha/lead_sources', params);
  }

  static update(params: Params & { uuid: string }) {
    return RestAPI.updateWithFormData(`/alpha/lead_sources/${params.uuid}`, params);
  }

  static delete(uuid: string) {
    return RestAPI.delete(`/alpha/lead_sources/${uuid}`);
  }

  static attach({ leadSourceUuid, sourceUuid, resourceType }: LeadSourceAttachParams) {
    return RestAPI.postWithFormData<LeadSource, Record<string, string>>(
      `/alpha/lead_sources/${leadSourceUuid}/attach`,
      { [resourceType]: sourceUuid }
    );
  }

  static detach({ sourceUuid, resourceType }: DettachLeadSourcesApi) {
    return RestAPI.postWithFormData<LeadSource, Record<string, string>>('/alpha/lead_sources/detach', {
      [resourceType]: sourceUuid,
    });
  }

  static bulkAttach(params: { lead_source_uuid: string }) {
    return RestAPI.postWithFormData(`/alpha/lead_sources/${params.lead_source_uuid}/bulk_attach`, params);
  }

  static bulkDetach(params: bulkDetachParams) {
    return RestAPI.postWithFormData(`/alpha/lead_sources/bulk_detach`, params);
  }
}
